import { render, staticRenderFns } from "./personalData.vue?vue&type=template&id=4974d093&scoped=true&"
import script from "./personalData.js?vue&type=script&lang=js&"
export * from "./personalData.js?vue&type=script&lang=js&"
import style0 from "./personalData.vue?vue&type=style&index=0&id=4974d093&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974d093",
  null
  
)

export default component.exports